import store from "@/store/index";

import BaseService from "./BaseService";

export default {
  get() {
    return BaseService.get("trends").then(response => {
      store.dispatch("trend/set", response.data);
    });
  },

  monthReport() {
    return BaseService.get("trends/month-report").then(
      response => response.data
    );
  },

  detailedReport(month) {
    return BaseService.get(`trends/detailed-report?month=${month}`).then(
      response => response.data
    );
  },

  downloadDailyReport(startDate) {
    return BaseService.get(
      `trends/detailed-report?start_date=${startDate}`
    ).then(response => response.data);
  },

  getPopularTimes(status = 0, dow = -1) {
    return BaseService.get(
      `trends/popular-times-report?status=${status}&dow=${dow}`
    ).then(response => {
      store.dispatch("trend/setPopularTimes", response.data);
    });
  }
};
